import { Brand, BrandAssetKind, LogoType } from "../../../models/brand.model.ts";
import { BrandSerializer } from "../../../models/serializers/brandSerializer.ts";
import { httpRequest } from "../../http";

/** An asset's details (MPN-1712). On the PATCH only the keys sent change, and null clears one. */
export interface BrandAssetFields {
    kind?: BrandAssetKind;
    logo_type?: LogoType | null;
    name?: string | null;
    description?: string | null;
    minimum_size?: string | null;
    usage_guidelines?: string | null;
}

export const brandAssetsUrl = (organizationId: string, brandId: string) =>
    `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/assets/`;

/** Uploads a file as a new asset of `fields.kind`. Answers with the brand, assets and all. */
export class CommandCreateBrandAsset {
    async run(organizationId: string, brandId: string, file: File, fields: BrandAssetFields): Promise<Brand> {
        const form = new FormData();
        form.append("file", file);
        for (const [field, value] of Object.entries(fields)) {
            if (value) form.append(field, value);
        }
        const response = await httpRequest<any>(brandAssetsUrl(organizationId, brandId), { method: "POST", body: form });
        return new BrandSerializer().deserialize(response);
    }
}
